import React from 'react';
import SearchBar from 'Common/Components/SearchBar/index';
import 'Common/styles/commonStyles.scss';
import { useSelector } from 'react-redux';
import { selectPathname } from 'store/Router/selectors';
import BasicSearcher from './BasicSearcher';
import { getShowNewSearcher, getShowOldSearcher } from 'Common/Components/SearchBar/routeVisibility';

const Searcher = () => {
  const pathname = useSelector(selectPathname);

  if (getShowNewSearcher(pathname)) return <SearchBar />;
  if (getShowOldSearcher(pathname)) return <BasicSearcher />;

  return null;
};

export default Searcher;
